import { useLocation, useNavigate } from "react-router-dom";
import { Card, ConfMeter } from "../components/Bits";
import { SignInButtons } from "../components/SignInButtons";
import { Sketch } from "../components/Sketch";
import { markWelcomed, useApp } from "../state";

const DEMO_PINS = [
  { zone: "waist", cls: "l1", name: "Waist: Some gape" },
  { zone: "hip", cls: "l1", name: "Hips: Roomier" },
  { zone: "rise", cls: "l0", name: "Crotch & rise: Like your favorite" },
  { zone: "thigh", cls: "l0", name: "Thighs: Like your favorite" },
  { zone: "length", cls: "l2", name: "Length: Too long" },
];

/** The hero from the demo. `welcome` is the first-visit version with a guest option. */
export function SignIn({ welcome }: { welcome?: boolean }) {
  const { me } = useApp();
  const nav = useNavigate();
  const loc = useLocation();
  const from = (loc.state as { from?: string } | null)?.from;
  const next = welcome ? "/" : from || "/";
  const signedIn = !me.user.is_guest;

  const goOn = () => {
    markWelcomed();
    nav(from || "/", { replace: true });
  };

  return (
    <section className="view enter">
      <h1>
        <span className="ph">
          How will it <em>fit?</em>
        </span>
      </h1>
      <div className="banner">
        <p className="aside">
          We show how garments will behave on you. No tape measure. No picking a size for you. You can <mark>choose what matters to you.</mark>
        </p>
        <p className="small">
          <b>Sign in so your next notes get sharper.</b>
        </p>
      </div>
      {signedIn ? (
        <div className="bcard">
          <span className="tag done">
            <b>✓</b>Signed in
          </span>
          <p>You're signed in{me.user.name ? ` as ${me.user.name}` : ""}.</p>
          <button className="btn primary" type="button" onClick={goOn}>
            Let's go
          </button>
        </div>
      ) : (
        <>
          <SignInButtons next={next} onSignedIn={goOn} />
          {welcome && (
            <button className="btn ghost" type="button" onClick={goOn}>
              Try it first, sign in later
            </button>
          )}
        </>
      )}
      <Card tag="What you'll see, for example" mark="M">
        <div className="stage">
          <Sketch cat="pants" pins={DEMO_PINS} animate active="waist" label="Example garment sketch with five fit spots" />
          <div className="zinfo">
            <div className="zhead">
              <h3>Waist</h3>
              <span className="v l1">Some gape</span>
            </div>
            <p>About 2½ in of gape at the back waist. A belt handles it.</p>
            <ConfMeter c={81} />
            <p className="aside" style={{ fontSize: "1rem" }}>
              Hover or tap any spot on the garment to read how it fits there.
            </p>
          </div>
        </div>
      </Card>
    </section>
  );
}
